/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ScanCell.vue?vue&type=template&id=1f38d5ec&scoped=true&"
import script from "./ScanCell.vue?vue&type=script&lang=js&"
export * from "./ScanCell.vue?vue&type=script&lang=js&"
import style0 from "./ScanCell.vue?vue&type=style&index=0&id=1f38d5ec&lang=less&scoped=true&"
import style1 from "./ScanCell.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38d5ec",
  null
  
)

export default component.exports